import { Slide } from '@/components/core/Slide';
import audioFile from './31-metal.mp3';

const autoNextDuration = 46000;
const transcript = `
  En nu metaalbedrijven...

  AI-gestuurde CNC-programmering kan automatisch CNC-programma's optimaliseren op basis van ontwerp- en 
  materiaalparameters, wat leidt tot efficiëntere productie.

  Met predictive maintenance kan AI sensordata analyseren en voorspellen wanneer machines onderhoud nodig 
  hebben, zodat uitval wordt voorkomen.

  Generatieve AI kan worden ingezet voor technische handleidingen, met automatische samenvatting en 
  vertaling van technische documentatie.

  En slimme kwaliteitscontrole met computer vision kan fabricagefouten detecteren bij producten en 
  automatisch afkeur registreren.

  Aldus: hogere productkwaliteit, minder stilstand, en snellere productie.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-8">Metaalbedrijven 🔩</h1>

        <ul className="space-y-4 list-disc">
          <li>AI-gestuurde CNC-programmering: Automatisch optimaliseren van programma's</li>
          <li>Predictive maintenance: Voorspellen wanneer machines onderhoud nodig hebben</li>
          <li>Generatieve AI voor technische handleidingen: Automatische samenvatting</li>
          <li>Slimme kwaliteitscontrole: Detecteren van fabricagefouten</li>
        </ul>
      </div>
    </Slide>
  );
};
